



























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import LiveDealsComponent from '@/components/LiveDealsComponent.vue';                       // @ is an alias to /src
import AlertDealsComponent from '@/components/AlertDealsComponent.vue';                       // @ is an alias to /src
import * as utils_tracker from '@/utils_tracker';
import * as utils_topshot from '@/utils_topshot';
import { TokenUser } from '@/TokenUser'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

export type modeType = 'live' | 'alerts'

@Component({
  name: 'Deals',
  components: { LiveDealsComponent, AlertDealsComponent, ModalWrapperComponent }
})

export default class Deals extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public mode: modeType = null

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  public showFAQ(): void {
    (this.$refs.FAQDealsComponent as ModalWrapperComponent).show('Deals FAQ', 'md', null)
  }

  // private, non-reactive member variables

  @Watch('mode')
  private async modeChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`Deals.modeChanged() ${this.mode}`)

    this.$router.replace(`/deals/${this.mode}`).catch(() => {})
  }

  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`Deals.pathChanged() ${this.$route.path}`)

    // use mode from URL if it exists
    if (this.$route.params.mode) {
      this.mode = this.$route.params.mode as modeType
    } else {
      this.mode = 'live'
    }
  }

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    if (this.user) utils_tracker.identify(this.user)

    await this.pathChanged()

    this.$router.replace(`/deals/${this.mode}`).catch(() => {})

  }

  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)
  }

}
